// Helper functions for SafeProvider
import { Connector } from 'wagmi'
import {
  MinimalEIP1193Provider,
  SafeConfigConnection,
  SafeConfigPrediction,
} from './types'
import { ContractNetworks } from './contractNetworks'
import { ADJECTIVES, NOUNS } from './constants'

export async function getMinimalEIP1193Provider(
  connector: Connector | undefined
): Promise<MinimalEIP1193Provider | null> {
  if (!connector) return null
  const rawProvider = await connector.getProvider()
  const baseProvider = rawProvider as MinimalEIP1193Provider
  return {
    request: baseProvider.request,
    on: baseProvider.on,
    removeListener: baseProvider.removeListener,
  }
}

export function createPredictionConfig(
  provider: MinimalEIP1193Provider | string,
  signer: string | undefined,
  owners: Array<`0x${string}`>,
  threshold: number,
  saltNonce?: string,
  contractNetworks?: ContractNetworks
): SafeConfigPrediction {
  return {
    provider,
    signer,
    predictedSafe: {
      safeAccountConfig: { owners, threshold },
      safeDeploymentConfig: saltNonce?.toString ? { saltNonce } : undefined,
    },
    contractNetworks: contractNetworks,
  }
}

export function createConnectionConfig(
  provider: MinimalEIP1193Provider | string,
  signer: string | undefined,
  safeAddress: `0x${string}`,
  contractNetworks?: ContractNetworks
): SafeConfigConnection {
  return {
    provider,
    signer,
    safeAddress,
    contractNetworks: contractNetworks,
  }
}

export function getRandomSafeName() {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)]
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)]
  return `${adj} ${noun}`
}

export function sanitizeUserInput(name: string): string {
  return name.replace(/<[^>]*>/g, '').replace(/[><'"`]/g, '')
}

export function isValidAddress(address: string): address is `0x${string}` {
  return /^0x[a-fA-F0-9]{40}$/.test(address)
}

export function havePredictionParamsChanged(
  prev: { network: unknown; signers: string[]; threshold: number },
  next: { network: unknown; signers: string[]; threshold: number }
): boolean {
  return (
    prev.network !== next.network ||
    prev.signers.join(',') !== next.signers.join(',') ||
    prev.threshold !== next.threshold
  )
}
